export const LOGO = "LOGO";
export const ABOUT_US = "ABOUT_US";
